import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Url extends PureComponent {
  render() {
    return (
      <div className="row" id="notifications_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Notifications Overview</h2>
              <p>
                Notifications are a great way to alert users of workflows and
                events without requiring third party email systems.
                Notifications have a built-in cleaning system. Once the
                notification has been read it will be deleted after 24 hours.
                Unread notifications will last for 30 days. Notifications can
                only be created programmatically either through the API or the
                NL library covered in workflow section of this website.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Url;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Notifications_overview.js